import React, { useContext, useState } from "react";
import {
  Box,
  Container,
  Typography,
  makeStyles,
  Button,
  Divider,
  IconButton,
  Dialog,
  DialogTitle,
  Slide,
  DialogContent,
  TextField,
  DialogActions,
  Grid,
} from "@material-ui/core";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { FaFacebookF, FaYoutube, FaInstagram } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { GrLinkedinOption } from "react-icons/gr";
import SettingsContext from "src/context/SettingsContext";
import { Link as RouterLink } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  footerSection: {
    overflow: "hidden",
    background: theme.palette.background.grey,
    position: "relative",
    padding: "30px 0px",
    zIndex: "2",
    color: theme.palette.text.primary,
  },
  copyrightText: {
    textAlign: "center",
    width: "100%",
    marginTop: "20px",
  },
  dialogContent: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    width: "350px",
  },
  fieldLabel: {
    fontSize: "1rem",
    fontWeight: "normal",
    color: theme.palette.type === "light" ? "black" : "white",
  },
  dialogTitle: {
    fontSize: "1.5rem",
    fontWeight: "bold",
    color: theme.palette.type === "light" ? "black" : "white",
  },
  textField: {
    "& .MuiOutlinedInput-root": {
      backgroundColor:
        theme.palette.type === "light"
          ? "#f0f0f0"
          : theme.palette.background.paper,
    },
  },
  footerLink: {
    padding: 0,
    justifyContent: "flex-start",
    textTransform: "none",
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const getImageUrl = (imageName) => {
  const isDevelopment = process.env.REACT_APP_ENV === "development";
  const adjustedImageName = isDevelopment
    ? imageName.replace(".svg", "_beta.svg")
    : imageName;
  return `${process.env.REACT_APP_IMAGE_BASE_URL}/${adjustedImageName}`;
};

export default function Liquidity() {
  const themeSeeting = useContext(SettingsContext);
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });

  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleChange = (event) => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
  };

  const handleSubmit = () => {
    const mailtoLink = `mailto:support@blockstats.app?subject=Support Request from ${formData.name}&body=${encodeURIComponent(
      `Name: ${formData.name}\nEmail: ${formData.email}\nMessage: ${formData.message}`
    )}`;
    window.location.href = mailtoLink;
    handleClose();
  };

  return (
    <>
      <Box className={classes.footerSection}>
        <Container maxWidth="lg">
          {/* CTA Section */}
          <Box textAlign="center" mb={5}>
            <Typography variant="h2" color="primary">Still Have Questions?</Typography>
            <Typography variant="h6" color="secondary">Our customer support service always ready to help you</Typography>
            <Box mt={3}>
              <Button variant="contained" color="primary" onClick={handleClickOpen}>
                Contact Us
              </Button>
            </Box>
          </Box>
          <Box className={classes.FooterBotom}>
            <Box>
              <LazyLoadImage
                effect="blur"
                alt="Blockstats Logo"
                src={getImageUrl(
                  themeSeeting.settings.theme === "LIGHT"
                    ? "logo_dark.svg"
                    : "logo_light.svg"
                )}
              />
            </Box>
            <Box className={classes.footerLinks}>
              <Button color="primary" component={RouterLink} to="/privacy-policy">Privacy Policy</Button>
              <Button color="primary" component={RouterLink} to="/terms-conditions">Terms of Use</Button>
              <Button color="primary" component={RouterLink} to="/blog">Blog</Button>
            </Box>
            <Box>
              <IconButton aria-label="Facebook" size="small" onClick={() => window.open("https://www.facebook.com/profile.php?id=61573291060125")}> <FaFacebookF /> </IconButton>
              <IconButton aria-label="twitter" size="small" onClick={() => window.open("https://x.com/Blockstats_app")}> <FaXTwitter /> </IconButton>
              <IconButton size="small" aria-label="linkedin" onClick={() => window.open("https://www.linkedin.com/company/blockstats/")}> <GrLinkedinOption /> </IconButton>
              <IconButton size="small" aria-label="youtube" onClick={() => window.open("https://www.youtube.com/@Blockstats")}> <FaYoutube /> </IconButton>
              <IconButton size="small" aria-label="instagram" onClick={() => window.open("https://www.instagram.com/blockstats.app")}> <FaInstagram /> </IconButton>
            </Box>
          </Box>

          {/* Copyright */}
          <Box className={classes.copyrightText}>
            <Typography variant="body2" color="secondary">
              © 2025 Blockstats. All Rights Reserved.
            </Typography>
          </Box>
        </Container>
      </Box>

      {/* Contact Modal */}
      <Dialog open={open} TransitionComponent={Transition} maxWidth="sm" fullWidth={false}>
        <DialogTitle className={classes.dialogTitle}>Contact Support</DialogTitle>
        <DialogContent className={classes.dialogContent}>
          <Typography className={classes.fieldLabel}>Name</Typography>
          <TextField name="name" fullWidth onChange={handleChange} variant="outlined" className={classes.textField} />
          <Typography className={classes.fieldLabel}>Email</Typography>
          <TextField name="email" type="email" fullWidth onChange={handleChange} variant="outlined" className={classes.textField} />
          <Typography className={classes.fieldLabel}>Message</Typography>
          <TextField name="message" multiline rows={4} fullWidth onChange={handleChange} variant="outlined" className={classes.textField} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">Cancel</Button>
          <Button onClick={handleSubmit} color="primary" variant="contained">Send</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
